import { Box } from '@mui/material';

import { ReturnComponent } from './reactTypes';

// We were having an issue where if someone searches for something like "Se", it would
//  match things in the navigation drawer, which is weird. So to exclude navigation drawer
//  labels from showing up in the browser Command-F/Ctrl-F search, we put the text
//  in the CSS `:before { content: ... }` property.
export const CommandFInvisibleText = ({ children }: { children: string }): ReturnComponent => {
    return (
        <Box
            component='span'
            sx={{
                '&:before': {
                    // The double quotes are important. Without that,
                    //  there will be an error, and the whole app will crash!
                    content: `"${children}"`,
                },
            }}
        />
    );
};
